import { h } from 'preact'; /** @jsx h */

import './Heading.scss';

const Heading = ({
    type = 'h2',
    weight = '400',
    color = 'off-black',
    className = '',
    children
}) => {
    let heading = null;

    switch (type) {
        case 'h1':
            heading = (
                <h1 className={`heading heading-h1 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h1>
            );
            break;
        case 'h2':
            heading = (
                <h2 className={`heading heading-h2 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h2>
            );
            break;
        case 'h3':
            heading = (
                <h3 className={`heading heading-h3 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h3>
            );
            break;
        case 'h4':
            heading = (
                <h4 className={`heading heading-h4 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h4>
            );
            break;
        case 'h5':
            heading = (
                <h5 className={`heading heading-h5 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h5>
            );
            break;
        case 'h6':
            heading = (
                <h6 className={`heading heading-h6 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h6>
            );
            break;
        default:
            heading = (
                <h2 className={`heading heading-h2 color-${color} weight-${weight} ${className}`}>
                    {children}
                </h2>
            );
            break;
    }

    return heading;
};

export default Heading;
